<div class="btw-row">
    <div class="btw-col-12">
        <btw-card title="Financial Statement Mapping">
            <span>This indicator shows evolution of balance sheet positions in real-time.</span>
        </btw-card>
    </div>
</div>

@if(dataSource) {
    <div class="btw-row">
        <div class="btw-col-12">
            <btw-chart [dataSource]="dataSource">
    
                @for(serie of series; track serie) {
                <btw-chart-series [name]="serie" [valueField]="serie" type="area-spline" groupName="group" />
                }
    
                <btw-chart-argument-axis field="date" type="timeseries">
                    <btw-chart-axis-tick format="%Y-%m-%d" />
                </btw-chart-argument-axis>
            </btw-chart>
        </div>
    </div>
    
    <table style="width: 100%;">
        <thead>
            <tr>
                <th>Date</th>
                @for(serie of series; track serie){
                <th [innerText]="serie"></th>
                }
            </tr>
        </thead>
        <tbody>
            @for (dataItem of dataSource; track dataItem.date) {
            <tr>
                <td [innerText]="dataItem['date'] | date: 'yyyy/MM/dd'"></td>
                @for (serie of series; track $index) {
                <td [innerText]="dataItem[serie]"></td>
                }
            </tr>
            }
        </tbody>
    </table>
}
